import {
  Alert,
  Box,
  Checkbox,
  Chip,
  FormControlLabel,
  Grid,
  InputLabel,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";

import useStyles from "./confirmationStyle";
import { useEffect, useRef, useState } from "react";
import FormField from "../../../../components/common/FormField";
import {
  clientConfirmationNoteFields,
  clientConfirmationSelfNoteFields,
  clientInsuranceFields,
  clientInsuranceGeneralFields,
  customerConfirmationNoteFields,
} from "./confirmationAllFields";
import ServiceConfirmation from "./ServiceConfirmation";
import {
  clientConfirm,
  confirmationClientValidateForm,
  getConfirmationServiceKey,
} from "./confirmationUtils";

import DateConfirmation from "./DateConfirmation";
import closeIcon from "../../../../assets/closeModel.png";
import checkedIcon from "../../../../assets/check-mark.png";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  getConfirmationAction,
  setResponseCancelInvoiceDeposit,
  setResponseTransferInvoice,
  updateConfirmationAction,
  setUpdateConfirmationAction,
  unassignServiceResponse,
} from "../../../../store/reducers/clientConfirmationSlice";
import ConfirmationActions from "./ConfirmationActions";
import Notification from "../../../../components/common/notification/Notification";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import dayjs from "dayjs";
import { getLeadColor } from "../../customerInvoice/InvoiceUntil";
import AlertOnSaveConfirmation from "../../manageLeads/AlertOnSaveConfirmation";
import Loader from "../../../../components/common/loader/Loader";
import LeadDetailSection from "../../lead/estimate/LeadDetailSection";
import { getLeadEstimateAction } from "../../../../store/reducers/leadSlice";

import { getAllSaleAction } from "../../../../store/reducers/saleSlice";
import { getAllSubContractorAction } from "../../../../store/reducers/subContractor";
import QuoteViewData from "./quoteViewData";
import { getFinancialAction } from "../../../../store/reducers/quickBookSlice";

interface ManageProfessionalConfirmationProps {
  show: boolean; // Define the 'open' prop
  onHide?: () => void; // Define the 'onHide' prop
  title?: string; // Define the 'title' prop
  selectLead?: any; // Adjust type as per your requirement
  action?: any;
  setSelectedLead?: any;
  setShow?: any;
  generateId?: any;
  onConfirmationSaved?: (isNewLead: boolean) => void;
}

const ManageProfessionalConfirmation: React.FC<
  ManageProfessionalConfirmationProps
> = (props) => {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(0);
  const lastUpdatedTabRef = useRef<number>(0); // Track last updated tab
  const [confirmationList, setConfirmationList] = useState<any[]>([]);
  const [subContractorOptions, setSubContractorOptions] = useState([]);
  const [formData, setFormData] = useState<any>(clientConfirm);
  const [isDoorToDoorAccept, setIsDoorToDoorAccept] = useState(true);
  const [isFullPackAccept, setIsFullPackAccept] = useState(true);
  const { onHide, show, setShow, generateId, onConfirmationSaved } = props;
  const moveToFinalAfterSaveRef = useRef(false);
  const [alertModelShow, setAlertModelShow] = useState(false);
  const {
    confirmationDetailsResponse,
    loaderMessage,
    isDepositResponse,
    isUnassignWorkerResponse,
    confirmationResponse,
  } = useSelector((state: any) => state.confirmation);
  const { subContractors } = useSelector((state: any) => state.subContractor);

  const [actionType, setActionType] = useState("");
  const { leadDetails, selectedLeadQuote } = useSelector(
    (state: any) => state.lead,
  );
  const dispatch = useDispatch();
  const [anyChangeFieldValue, setAnyChangeFieldValue] = useState(false);
  const { userProfile } = useSelector((state: any) => state?.user);
  const [isTesterSection, setIsTesterSection] = useState(true);

  useEffect(() => {
    if (show) {
      lastUpdatedTabRef.current = -1;
    }
  }, [show]);

  useEffect(() => {
    setIsTesterSection(
      userProfile?.features?.includes("Basic Work Diary") || false,
    ); // Sync profile changes
  }, [userProfile]);

  useEffect(() => {
    dispatch(
      getAllSubContractorAction({
        page: 1,
        limit: 100,
        orderBy: "created_at",
        orderIn: "DESC",
      }),
    );
    dispatch(getFinancialAction());
  }, []);

  useEffect(() => {
    if (subContractors && subContractors.length) {
      const subContractorLocal: any = [];
      subContractors &&
        subContractors.map((ele: any) => {
          subContractorLocal.push({ id: ele?.id, name: ele?.aka_name });
        });
      setSubContractorOptions(subContractorLocal);
    } else {
      setSubContractorOptions([]);
    }
  }, [subContractors]);

  // -----------------------------
  // Handle API response
  // -----------------------------

  useEffect(() => {
    if (
      Array.isArray(confirmationDetailsResponse) &&
      confirmationDetailsResponse.length > 0 &&
      selectedLeadQuote?.quotes?.length > 0
    ) {
      // Determine which tab to show - use last updated tab if available and valid, otherwise show last tab
      const tabToShow =
        lastUpdatedTabRef.current >= 0 &&
        lastUpdatedTabRef.current < confirmationDetailsResponse.length
          ? lastUpdatedTabRef.current
          : confirmationDetailsResponse.length - 1;

      const confirmation = confirmationDetailsResponse[tabToShow];
      const quote = selectedLeadQuote.quotes[tabToShow];

      setConfirmationList(confirmationDetailsResponse);
      setActiveTab(tabToShow);
      setFormData({
        // ✅ confirmation data
        ...confirmation,
        services: (confirmation?.services || []).map((service: any) => ({
          ...service,
          savedJobStatus: service.jobStatus,
        })),
        isQuoteAccepted: confirmation?.isQuoteAccepted || false,
        // ✅ quote data
        materials: quote?.materials || [],
        materialPriceChargeable: quote?.materialPriceChargeable || false,
        ancillaries: quote?.ancillaries || [],
        subcontractorCharges: quote?.subcontractorCharges || [],
        generalInfo: quote?.generalInfo || {},
        quoteTotal: confirmation?.quote_total || confirmation?.quoteTotal || 0,
        costTotal: quote?.costTotal || 0,
        quoteExpiresOn: quote?.quoteExpiresOn || null,
        insuranceAmount: quote?.insuranceAmount || 0,
        contentValue: confirmation?.contentValue || 0,
        insurancePercentage: quote?.insurancePercentage || 0,
        insuranceType: quote?.insuranceType || "",
        accepted_status: quote?.accepted_status || "",
        confirmationNote: confirmation?.confirmationNote || "",
        isJobCreated: confirmation?.isJobCreated || false,
        isWorkerAssigned: confirmation?.isWorkerAssigned || false,
        quoteId: quote?.quoteId,
      });

      const services = confirmation?.services || [];
      const doorTodoor = services.find(
        (ele: any) => ele?.type?.toLowerCase() === "removal",
      );
      const fullPack = services.find(
        (ele: any) => ele?.type?.toLowerCase() === "fullpack",
      );

      setIsDoorToDoorAccept(doorTodoor?.status !== "accept");
      setIsFullPackAccept(fullPack?.status !== "accept");
    } else {
      setConfirmationList([]);
      setFormData(clientConfirm);
    }
  }, [confirmationDetailsResponse, selectedLeadQuote]);

  useEffect(() => {
    dispatch(getConfirmationAction(generateId));
    dispatch(
      getLeadEstimateAction({
        generatedId: generateId,
        screenType: "quotation",
      }),
    );
    dispatch(getAllSaleAction());
    dispatch(setResponseCancelInvoiceDeposit(false));
    dispatch(setResponseTransferInvoice(false));
    dispatch(unassignServiceResponse(false));
  }, [dispatch, generateId, isUnassignWorkerResponse, isDepositResponse]);

  const [error, setError] = useState(null);

  // Tab handlers
  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    lastUpdatedTabRef.current = newValue; // Update last updated tab
  };

  const handleSubmit = () =>
    // event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    {
      const { isError, localError } = confirmationClientValidateForm(
        formData,
        isFullPackAccept,
        isDoorToDoorAccept,
        isTesterSection,
      );

      const hasDateRangeError = formData?.services?.some((service: any) => {
        const serviceErrorKey = getConfirmationServiceKey(
          service,
          formData.services.indexOf(service),
        );
        return Boolean(localError?.services?.[serviceErrorKey]?.endDate);
      });

      const manualErrors: Record<string, string> = {};
      // if (!formData?.confirmedOn) {
      //   manualErrors.confirmedOn = "Confirmed On is required";
      // }
      if (!formData?.isQuoteAccepted) {
        manualErrors.isQuoteAccepted = "Accepted Status is required";
      }

      // 🧹 Remove movingDate and packingDate errors (if any)
      delete localError.movingDate;
      delete localError.packingDate;

      const mergedErrors = {
        ...localError,
        ...manualErrors,
      };

      const hasErrors =
        Object.keys(mergedErrors).length > 0 || hasDateRangeError;
      setError(hasErrors ? mergedErrors : null);

      if (hasErrors) {
        // Date/service section gets first priority for focus.
        setTimeout(() => {
          if (mergedErrors?.services) {
            return;
          }

          const focusFieldId = manualErrors.confirmedOn
            ? "confirmedOn"
            : "isQuoteAccepted";
          const targetInput = document.querySelector(
            `input[name="${focusFieldId}"], input[id="${focusFieldId}"]`,
          ) as HTMLInputElement | null;

          if (targetInput) {
            targetInput.focus();
            targetInput.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 0);

        setAlertModelShow(false);
        setIsShowActionCalled(false);
        return;
      }

      setAlertModelShow(false);
      if (!isError) {
        // Remeber active tab
        // remember current tab
        lastUpdatedTabRef.current = activeTab;
        setActiveTab(activeTab);
        // Format date to "YYYY-MM-DD"
        const formatDate = (date: any) => {
          return date ? dayjs(date).format("YYYY-MM-DD") : null;
        };

        // Create a copy of formData to modify it
        const {
          invoiceNumber,
          invoiceType,
          movingDate,
          packingDate,
          services,
          generalInfo,
          ancillaries,
          materials,
          subcontractorCharges,
          createdAt,
          quoteId,
          quoteTotal,
          costTotal,
          quoteExpiresOn,
          insuranceAmount,
          insurancePercentage,
          insuranceType,
          accepted_status,
          ...rest
        }: any = formData;

        const formattedServices = services?.map((service: any) => ({
          ...service,
          startDate: formatDate(service.startDate),
          endDate: formatDate(service.endDate),
        }));

        const formPayload = {
          ...rest,
          services: formattedServices,
          contentValue: Number(formData?.contentValue),
          generateId,
        };
        console.log("formPayload", formPayload);
        if (!actionType || anyChangeFieldValue) {
          moveToFinalAfterSaveRef.current = Boolean(onConfirmationSaved);
          dispatch(setUpdateConfirmationAction(null));
          dispatch(updateConfirmationAction(formPayload));
          // setShow(false);
          // setAnyChangeFieldValue(false);
        }
      }
      setIsShowActionCalled(false);
      setAnyChangeFieldValue(false);
    };

  useEffect(() => {
    if (confirmationResponse && moveToFinalAfterSaveRef.current) {
      moveToFinalAfterSaveRef.current = false;
      onConfirmationSaved?.(false);
    }
  }, [confirmationResponse, onConfirmationSaved]);

  const [isShowActionCalled, setIsShowActionCalled] = useState(false);

  // Only call handleSubmit (save) when needed, but do NOT trigger send-email until save is successful
  useEffect(() => {
    if (isShowActionCalled) {
      handleSubmit();
      // Do NOT setIsShowActionCalled(false) here; let ConfirmationActions handle after save
    }
  }, [isShowActionCalled]);

  // Reset confirmationResponse only after ConfirmationActions triggers sendEmail/submitHandler
  // (Do not reset immediately after save, or child won't see the change)
  const isDisabled =
    leadDetails?.lead?.status === "COMPLETED" ||
    leadDetails?.lead?.status === "LOST" ||
    leadDetails?.lead?.status === "DISPUTE" ||
    leadDetails?.lead?.status === "JOB" ||
    leadDetails?.lead?.status === "DEBTOR" ||
    leadDetails?.lead?.status === "STORAGE" ||
    leadDetails?.lead?.status === "EXTERNAL";
const isLeadCompletedDisabled = leadDetails?.lead?.status === "COMPLETED" || leadDetails?.lead?.status === "STORAGE";
  const isCheckedQuoteStatus = leadDetails?.lead?.status === "QUOTE";

  const getDepositBadge = (item: any) => {
    if (!item.invoiceNumber) {
      return {
        label: "No Deposit",
        bg: "#F5F5F5",
        color: "#616161",
      };
    }

    if (item.isDepositeRecieved) {
      return {
        label: "Deposit Paid",
        bg: "#E3F2FD",
        color: "#1565C0",
      };
    }

    return {
      label: "Deposit Raised",
      bg: "#FFF3E0",
      color: "#EF6C00",
    };
  };

  const newServices =
    formData?.services?.filter((service: any) => service?.isNew === true) || [];

  const newServiceCount = newServices.length;

  const newServiceNumbers = newServices
    .map((service: any) => service?.orderIndex)
    .filter(Boolean);

  const getOrdinal = (number: number) => {
    const suffix =
      number % 100 >= 11 && number % 100 <= 13
        ? "th"
        : number % 10 === 1
          ? "st"
          : number % 10 === 2
            ? "nd"
            : number % 10 === 3
              ? "rd"
              : "th";

    return `${number}${suffix}`;
  };

  const formatServiceNumbers = (numbers: number[]) => {
    if (numbers.length === 0) return "";

    const formattedNumbers = numbers.map(getOrdinal);

    if (formattedNumbers.length === 1) {
      return formattedNumbers[0];
    }

    if (formattedNumbers.length === 2) {
      return `${formattedNumbers[0]} and ${formattedNumbers[1]}`;
    }

    return `${formattedNumbers.slice(0, -1).join(", ")} and ${
      formattedNumbers[formattedNumbers.length - 1]
    }`;
  };

  return (
    <>
      {loaderMessage !== "" && <Loader />}
      {alertModelShow && (
        <AlertOnSaveConfirmation
          open={alertModelShow}
          title="Confirmation"
          onHide={() => setAlertModelShow(false)}
          setAlertModelShow={setAlertModelShow}
          submitHandler={handleSubmit}
        />
      )}
      <div
        id="estimate-popup-fixed"
        className={classes.estimatePopupContainer}
        style={{
          zIndex: show ? 11 : -1,
        }}
      >
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={12}
            sx={{ height: "45px", zIndex: 99, paddingLeft: "0px" }}
          >
            <div className={classes.popupTitle} style={{ padding: "4px 10px" }}>
              <Box
                sx={{
                  display: "inline-block",
                  px: 3,
                  py: 1,
                  backgroundColor: getLeadColor("CONFIRMED"),
                  color: "white",
                  clipPath:
                    "polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 25% 50%, 0% 0%)",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    marginLeft: "2px",
                    paddingLeft: "6px !important",
                  }}
                  variant="subtitle1"
                >
                  Confirm
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "20px",
                  color: getLeadColor("CONFIRMED"),
                }}
                variant="subtitle1"
              >
                Confirmation
              </Typography>
              <Box>
                {leadDetails?.lead?.status === "COMPLETED" || leadDetails?.lead?.status === "STORAGE" ||
                (leadDetails?.lead?.status === "JOB" &&
                  formData?.isWorkerAssigned) ||
                isDoorToDoorAccept ? (
                  ""
                ) : (
                  <img
                    onClick={(e) =>
                      isCheckedQuoteStatus
                        ? setAlertModelShow(true)
                        : handleSubmit()
                    }
                    src={checkedIcon}
                    style={{
                      cursor: "pointer",
                      height: "26px",
                      width: "26px",
                      marginRight: 10,
                    }}
                    alt="save"
                  />
                )}
                <img
                  src={closeIcon}
                  style={{ cursor: "pointer", height: "26px", width: "26px" }}
                  onClick={() => {
                    setShow(false);
                    dispatch(
                      setNotificationAction({ message: [], severity: "error" }),
                    );
                  }}
                  alt="cross-icon"
                />
              </Box>
              {/* <CustomButton
                title="Return"
                onClick={() => {
                  setShow(false);
                  dispatch(
                    setNotificationAction({ message: [], severity: "error" })
                  );
                  // setEstimateForm(null)
                  // setError(null)
                }}
              /> */}
            </div>
          </Grid>
          <Grid item xs={12} sm={12} sx={{ paddingLeft: "0px !important" }}>
            <Notification />
            <Grid container spacing={0.5} sx={{ fontSize: "13px" }}>
              <Grid
                item
                xs={12}
                sm={12}
                sx={{
                  paddingLeft: "0px !important",
                  paddingTop: "0px !important",
                }}
              >
                <LeadDetailSection
                  leadDetails={leadDetails}
                  fontSize={"13px"}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/* Tabs Section - Above Services */}
        <Box
          sx={{
            borderBottom: 1.5,
            borderColor: "divider",
            display: "flex",
            alignItems: "center",
            backgroundColor: "#fff",
            padding: "10px 16px",
            gap: 1,
            marginBottom: "10px",
            borderRadius: "5px 5px 0 0",
          }}
        >
          <Tabs
            value={activeTab}
            onChange={(_e, newValue) => {
              setActiveTab(newValue);
              lastUpdatedTabRef.current = newValue; // ⭐ remember last tab
              const confirmation = confirmationList[newValue];
              const quote = selectedLeadQuote?.quotes?.[newValue] || {};
              const services = confirmation?.services || [];
              const doorTodoor = services.find(
                (ele: any) => ele?.type?.toLowerCase() === "removal",
              );
              const fullPack = services.find(
                (ele: any) => ele?.type?.toLowerCase() === "fullpack",
              );

              setIsDoorToDoorAccept(doorTodoor?.status !== "accept");
              setIsFullPackAccept(fullPack?.status !== "accept");

              setFormData({
                ...confirmation,
                services: (confirmation?.services || []).map(
                  (service: any) => ({
                    ...service,
                    savedJobStatus: service.jobStatus,
                  }),
                ),
                // Add quote data fields here
                isQuoteAccepted: confirmation?.isQuoteAccepted || false,
                materials: quote?.materials || [],
                materialPriceChargeable:
                  quote?.materialPriceChargeable || false,
                ancillaries: quote?.ancillaries || [],
                subcontractorCharges: quote?.subcontractorCharges || [],
                generalInfo: quote?.generalInfo || {},
                quoteTotal:
                  confirmation?.quote_total || confirmation?.quoteTotal || 0,
                costTotal: quote?.costTotal || 0,
                quoteExpiresOn: quote?.quoteExpiresOn || null,
                insuranceAmount: quote?.insuranceAmount || 0,
                insurancePercentage: quote?.insurancePercentage || 0,
                insuranceType: quote?.insuranceType || "",
                accepted_status: quote?.accepted_status || "",
                quoteId: quote?.quoteId,
                isWorkerAssigned: confirmation?.isWorkerAssigned || false,
              });
            }}
            variant="scrollable"
            scrollButtons="auto"
          >
            {confirmationList.map((item: any, index: number) => {
              const deposit = getDepositBadge(item);

              return (
                <Tab
                  key={item.confirmationId || index}
                  label={
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="flex-start"
                    >
                      {/* Date */}
                      <span>
                        {`${index + 1}-${
                          item.createdAt
                            ? new Date(item.createdAt).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "2-digit",
                                },
                              )
                            : ""
                        }`}
                      </span>

                      {/* Small Badge */}
                      <Chip
                        label={deposit.label}
                        size="small"
                        sx={{
                          mt: 0.5,
                          fontSize: "10px",
                          height: "16px",
                          backgroundColor: "#E0E0E0",
                          color: deposit.color,
                        }}
                      />
                    </Box>
                  }
                  sx={{
                    textTransform: "none",
                    fontSize: "13px",
                    fontWeight: 500,
                    borderRadius: "6px",
                    mr: 1,
                    backgroundColor: item?.isQuoteAccepted
                      ? "#E8F5E9"
                      : "#F5F5F5",
                    // border: item?.isQuoteAccepted
                    //   ? "1px solid #4CAF50"
                    //   : "1px solid #BDBDBD",
                    color: item?.isQuoteAccepted ? "#2E7D32" : "#757575",
                    opacity: item?.isQuoteAccepted ? 1 : 0.8,
                  }}
                />
              );
            })}
          </Tabs>
        </Box>
        {!formData?.isQuoteAccepted && formData?.invoiceNumber && (
          <>
            <Alert
              severity="warning"
              sx={{ width: "100%", mb: 2, fontSize: "13px" }}
            >
              Deposit Action Required for Declined Quotes
            </Alert>
          </>
        )}
        {leadDetails?.lead?.status === "CONFIRMED" && (
          <Alert
            severity="warning"
            sx={{ width: "100%", mb: 2, fontSize: "13px" }}
          >
            {formData?.isVehicleAssigned
              ? "This confirmation has already been processed. You must contact the Operations team if you wish to make any changes"
              : "This lead has already been confirmed"}
          </Alert>
        )}

        {newServiceCount > 0 && (
          <Alert
            severity="warning"
            sx={{
              mb: 1,
              width: "100%",
              fontSize: "13px",
            }}
          >
            {/* {formatServiceNumbers(newServiceNumbers)} additional{" "}
            {newServiceNumbers.length === 1 ? "service" : "services"} pending
            confirmation. */}
            {newServiceCount} additional{" "}
            {newServiceCount === 1 ? "service" : "services"} pending
            confirmation.
          </Alert>
        )}

        <Alert severity="info" sx={{ mb: 1, width: "100%" }}>
          You will have to resend the quotation if any of the services is marked
          Not Taking.
        </Alert>
        <Grid
          container
          spacing={0.5}
          sx={{
            background: "#E5F4F1",
            borderRadius: "5px",
            border: "1px solid #CFCFCF",
            overflow: "hidden",
            mt: 1,
            // pointerEvents: isDisabled ? "none" : "auto", // disable clicks
            // cursor: isDisabled ? "not-allowed" : "default", // show not-allowed cursor
            // // opacity: isDisabled ? 0.6 : 1, // optional: visually show disabled
          }}
        >
          <Grid
            item
            xs={12}
            md={5}
            sx={{
              paddingLeft: "0px !important",
              // pointerEvents: isDisabled ? "none" : "auto",
              // cursor: isDisabled ? "not-allowed" : "default",
            }}
          >
            <ServiceConfirmation
              error={error}
              formData={formData}
              setFormData={setFormData}
              setError={setError}
              isDisabled={isDisabled}
              setIsDoorToDoorAccept={setIsDoorToDoorAccept}
              setIsFullPackAccept={setIsFullPackAccept}
              setAnyChangeFieldValue={setAnyChangeFieldValue}
            />
          </Grid>
          <Grid item md={7} sx={{ paddingLeft: "0px !important" }}>
            <DateConfirmation
              error={error}
              setError={setError}
              formData={formData}
              setFormData={setFormData}
              isDisabled={isDisabled}
              isDoorToDoorAccept={isDoorToDoorAccept}
              isFullPackAccept={isFullPackAccept}
              setAnyChangeFieldValue={setAnyChangeFieldValue}
            />
          </Grid>
          <Grid
            container
            spacing={1.5}
            sx={{
              marginLeft: "0px !important",
              width: "100% !important",
              paddingLeft: "10px !important",
              background: "#E5F4F1",
              borderRadius: "5px",
              border: "1px solid #CFCFCF",
              overflow: "hidden",
              mt: 1,
            }}
          >
            <Grid
              item
              xs={12}
              sm={1.5}
              alignItems="center"
              sx={{
                margin: "0!important",
                display: "flex",
                alignItems: "center",
                paddingLeft: "0px !important",
              }}
            >
              <InputLabel
                sx={{
                  color: "#333333",
                  fontWeight: 600,
                  fontSize: "18px",
                  textWrap: "wrap",
                  lineHeight: 1.1,
                }}
                shrink
                htmlFor={"paymentMethod"}
              >
                Insurance :
              </InputLabel>
            </Grid>
            <Grid
              item
              xs={12}
              md={1.6}
              sx={{
                display: "flex",
                paddingLeft: "0px !important",
                paddingRight: "10px !important",
              }}
            >
              <Grid
                container
                spacing={0}
                sx={{
                  display: "flex",
                  marginTop: "0px",
                }}
              >
                <>
                  {clientInsuranceGeneralFields.map(
                    (field: any, idx: number) => {
                      return (
                        <FormField
                          key={idx}
                          onPaste={(
                            e: React.ClipboardEvent<HTMLInputElement>,
                          ) => e.preventDefault()}
                          {...{
                            ...field,
                            variant: "outlined", // Adding this variant prop
                            isNonMarginTop: true,
                            value: formData
                              ? formData?.insurancePercentage
                              : "",
                            disabled: true,
                            inSingleGridForm: true,
                            InputProps: {
                              ...(field?.inputProps && field?.inputProps),
                              autocomplete: "off",

                              sx: {
                                padding: "2px 4px",
                                height: "36px",
                                // width:'120px'
                              },
                            },
                          }}
                        />
                      );
                    },
                  )}
                </>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              md={8.4}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                paddingLeft: "0px !important",
              }}
            >
              {clientInsuranceFields.map((field: any, idx: number) => {
                return (
                  <FormField
                    key={idx}
                    onPaste={(e: React.ClipboardEvent<HTMLInputElement>) =>
                      e.preventDefault()
                    }
                    {...{
                      ...field,
                      type: field?.type,
                      variant: "outlined", // Adding this variant prop
                      isNonMarginTop: true,
                      value: formData ? formData?.[field?.id] : "",
                      disabled:
                        field?.id === "isInsuranceAccepted" &&
                        !formData?.isJobCreated
                          ?  isLeadCompletedDisabled ||false
                          : true,
                      onChange:
                        field?.id === "isInsuranceAccepted"
                          ? (e: React.ChangeEvent<HTMLInputElement>) => {
                              setFormData((prev: any) => ({
                                ...prev,
                                [field.id]:
                                  e.target.value === "true" ? true : false,
                              }));
                            }
                          : undefined,
                      inSingleGridForm: true,
                      GridFieldStyle: {
                        paddingRight: "10px !important",
                      },
                      InputProps: {
                        ...field?.inputProps,
                        autocomplete: "off",
                        startAdornment: (
                          <span
                            style={{
                              marginRight: "0px",
                              paddingTop: "1px",
                              fontWeight: 600,
                              fontSize: "14px",
                            }}
                          >
                            £
                          </span>
                        ),
                        sx: {
                          padding: "2px 4px",
                          height: "36px",
                          // width: "120px",
                        },
                      },
                    }}
                  />
                );
              })}
            </Grid>
            {Number(formData?.insurancePercentage) > 0 &&
              Number(formData?.insuranceAmount) > 0 && (
                <Alert
                  severity="warning"
                  sx={{ width: "100%", mb: 2, fontSize: "13px" }}
                >
                  Insurance should be marked accepted.
                </Alert>
              )}
          </Grid>
          <QuoteViewData
            formData={formData}
            setFormData={setFormData}
            subContractorOptions={subContractorOptions}
            isDisabled={isDisabled}
            isTesterSection={isTesterSection}
            error={error}
          />
        </Grid>
        <Grid container spacing={0.5} sx={{ marginTop: "4px" }}>
          {/* Insurance UI */}
          <Grid
            container
            spacing={1.5}
            sx={{
              marginLeft: "0px !important",
              width: "100% !important",
              paddingLeft: "10px !important",
              background: "#E5F4F1",
              borderRadius: "5px",
              border: "1px solid #CFCFCF",
              overflow: "hidden",
              mt: 1,
            }}
          >
            {/*property size  */}
            <Grid
              item
              xs={12}
              md={2.5}
              className={classes.labelBox}
              alignItems="center"
              sx={{
                display: "flex",
                alignItems: "center",
                // marginLeft:'4px'
              }}
            >
              <InputLabel
                sx={{
                  color: "#333333",
                  fontWeight: 600,
                  fontSize: "17px",
                  textWrap: "wrap",
                  lineHeight: 1,
                }}
                shrink
                htmlFor={""}
              >
                Existing property Size :
              </InputLabel>
              {/* Drivers */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  paddingTop: "0px",
                }}
              >
                <Typography variant="subtitle1" sx={{ mr: "4px" }}>
                  {formData?.collectionAddresses
                    ? formData?.collectionAddresses[0]?.volume
                      ? formData?.collectionAddresses[0]?.volume
                      : "0"
                    : "0"}
                </Typography>
                <Typography variant="body1">
                  {formData?.collectionAddresses
                    ? formData?.collectionAddresses[0]?.volume_unit
                      ? formData?.collectionAddresses[0]?.volume_unit
                      : ""
                    : ""}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          {/* notes */}
          <Grid
            container
            spacing={1.5}
            sx={{
              marginTop: "10px",
              marginLeft: "0px !important",
              width: "100% !important",
              padding: "0px 10px 10px 0px",
              background: "#E5F4F1",
              borderRadius: "5px",
              border: "1px solid #CFCFCF",
              
            }}
          >
            {clientConfirmationNoteFields.map((field: any, idx: number) => {
              // special case for type === "title"
              if (field.type === "title") {
                return (
                  <Grid
                    key={idx}
                    item
                    xs={12}
                    sm={field.md || 1.5}
                    className={classes.labelBox}
                    sx={{
                      margin: "10!important",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px !important",
                    }}
                  >
                    <InputLabel
                      sx={{
                        color: "#333333",
                        fontWeight: 600,
                        fontSize: "18px",
                        textWrap: "wrap",
                        lineHeight: 1.1,
                        display: "flex",
                      }}
                      shrink
                    >
                      {field?.label ? field?.label + " : " : ""}
                      {field?.isRequired && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                    </InputLabel>
                  </Grid>
                );
              }
              return (
                <FormField
                  // key={field.id}
                  onPaste={(e: React.ClipboardEvent<HTMLInputElement>) =>
                    e.preventDefault()
                  }
                  {...{
                    ...field,
                    id: field?.id,
                    // type: "textarea",
                    variant: "outlined", // Adding this variant prop
                    isNonMarginTop: true,
                    checked: formData?.isQuoteAccepted || false,
                    value:
                      field?.id === "isQuoteAccepted"
                        ? formData?.isQuoteAccepted
                          ? formData?.isQuoteAccepted
                          : ""
                        : formData
                          ? formData?.[field?.id]
                          : "",
                    inSingleGridForm: true,
                    disabled: field?.disabled ?? isLeadCompletedDisabled ?? false,
                    // editReadOnly: true,
                    multiline: true,
                    minRows: 2,
                    InputProps: {
                      sx: {
                        padding: "2px 4px",
                        height: "36px",
                        resize: "none",
                        // marginBottom: "6px !important",
                      },
                    },
                    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                      const nextValue =
                        field?.id === "isQuoteAccepted"
                          ? e.target.checked
                          : e.target.value;

                      setFormData({
                        ...formData,
                        [field?.id]: nextValue,
                      });

                      if (field?.id === "isQuoteAccepted") {
                        setError((prev: any) => {
                          if (!prev) return prev;
                          const { isQuoteAccepted, ...rest } = prev;
                          return Object.keys(rest).length > 0 ? rest : null;
                        });
                      }

                      setAnyChangeFieldValue(true);
                    },
                    GridLabelStyle: {
                      height: "46%",
                      marginBottom: "10px",
                    },
                    InputLabelProps: {
                      sx: {
                        WrapText: "normal",
                        whiteSpace: "pre-wrap",
                        // height: 'calc(100%)',
                        height: "auto",
                      },
                    },
                    error: Boolean(error && (error as any)[field?.id]),
                    // helperText: error && (error as any)[field?.id],
                  }}
                />
              );
            })}
          </Grid>
          {/* customer notes */}

          <Grid
            container
            spacing={1.5}
            sx={{
              marginTop: "8px",
              marginLeft: "0px !important",
              width: "100% !important",
              padding: "0px 10px 10px 0px",
              background: "#E5F4F1",
              borderRadius: "5px",
              border: "1px solid #CFCFCF",
            }}
          >
            {customerConfirmationNoteFields.map((field: any, idx: number) => {
              // special case for type === "title"
              if (field.type === "title") {
                return (
                  <Grid
                    key={idx}
                    item
                    xs={12}
                    sm={field.md || 1.5}
                    className={classes.labelBox}
                    sx={{
                      margin: "10!important",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px !important",
                    }}
                  >
                    <InputLabel
                      sx={{
                        color: "#333333",
                        fontWeight: 600,
                        fontSize: "18px",
                        textWrap: "wrap",
                        lineHeight: 1.1,
                      }}
                      shrink
                    >
                      {field.label} :
                    </InputLabel>
                  </Grid>
                );
              }
              return (
                <FormField
                  // key={field.id}
                  onPaste={(e: React.ClipboardEvent<HTMLInputElement>) =>
                    e.preventDefault()
                  }
                  {...{
                    ...field,
                    id: field?.id,
                    // type: "textarea",
                    variant: "outlined", // Adding this variant prop
                    isNonMarginTop: true,
                    value: formData ? formData?.[field?.id] : "",
                    // options: ['Go Cardless'],
                    disabled: true,
                    editReadOnly: true,
                    inSingleGridForm: true,
                    multiline: true,
                    minRows: 1.5,
                    InputProps: {
                      sx: {
                        padding: "2px 4px",
                        height: "36px",
                        resize: "none",
                        // marginBottom: "6px !important",
                      },
                    },
                    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                      setFormData({
                        ...formData,
                        [field?.id]: e.target.value, // Fix: Ensure value updates properly
                      });
                      setAnyChangeFieldValue(true);
                    },
                    GridLabelStyle: {
                      height: "54%",
                      marginBottom: "10px",
                    },
                    InputLabelProps: {
                      sx: {
                        WrapText: "normal",
                        whiteSpace: "pre-wrap",
                        // height: 'calc(100%)',
                        height: "auto",
                      },
                    },
                  }}
                />
              );
            })}
          </Grid>

          {/* notes */}
          <Grid
            container
            spacing={1.5}
            sx={{
              marginTop: "8px",
              marginBottom: "8px",
              marginLeft: "0px !important",
              width: "100% !important",
              padding: "0px 10px 10px 0px",
              background: "#E5F4F1",
              borderRadius: "5px",
              border: "1px solid #CFCFCF",
              pointerEvents: isDisabled ? "none" : "auto", // disable clicks
              cursor: isDisabled ? "not-allowed" : "default", // show not-allowed cursor
              // opacity: isDisabled ? 0.6 : 1, // optional: visually show disabled
            }}
          >
            {clientConfirmationSelfNoteFields.map((field: any, idx: number) => {
              // special case for type === "title"
              if (field.type === "title") {
                return (
                  <Grid
                    key={idx}
                    item
                    xs={12}
                    sm={field.md || 1.5}
                    className={classes.labelBox}
                    sx={{
                      margin: "10!important",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px !important",
                    }}
                  >
                    <InputLabel
                      sx={{
                        color: "#333333",
                        fontWeight: 600,
                        fontSize: "18px",
                        textWrap: "wrap",
                        lineHeight: 1.1,
                      }}
                      shrink
                    >
                      {field.label} :
                    </InputLabel>
                  </Grid>
                );
              }
              return (
                <FormField
                  // key={field.id}
                  onPaste={(e: React.ClipboardEvent<HTMLInputElement>) =>
                    e.preventDefault()
                  }
                  {...{
                    ...field,
                    id: field?.id,
                    // type: "textarea",
                    variant: "outlined", // Adding this variant prop
                    isNonMarginTop: true,
                    value:
                      field?.id === "confirmationNote"
                        ? formData?.confirmationNote
                        : confirmationDetailsResponse
                          ? confirmationDetailsResponse?.[field?.id]
                          : "",
                    inSingleGridForm: true,
                    // options: ['Go Cardless'],
                    // disabled: true,
                    // editReadOnly: true,
                    multiline: true,
                    // minRows: 3,
                    InputProps: {
                      sx: {
                        padding: "2px 4px",
                        height: "36px",
                        resize: "none",
                        // marginBottom: "6px !important",
                      },
                    },
                    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                      setFormData({
                        ...formData,
                        [field?.id]: e.target.value, // Fix: Ensure value updates properly
                      });
                      setAnyChangeFieldValue(true);
                    },
                    GridLabelStyle: {
                      height: "56%",
                      marginBottom: "10px",
                    },
                    InputLabelProps: {
                      sx: {
                        WrapText: "normal",
                        whiteSpace: "pre-wrap",
                        // height: 'calc(100%)',
                        height: "auto",
                      },
                    },
                  }}
                />
              );
            })}
          </Grid>
          {formData?.isDepositeRecieved && formData?.invoiceNumber !== null && (
            <FormControlLabel
              label="Deposit received"
              labelPlacement="end"
              control={
                <Checkbox
                  sx={{
                    marginTop: "0",
                    marginLeft: "0 !important",
                    width: "auto !important",
                  }}
                  checked={formData?.isDepositeRecieved}
                  disabled={true}
                  onChange={(event) => {
                    setFormData({
                      ...formData,
                      isDepositeRecieved: event.target.checked,
                    });
                    setAnyChangeFieldValue(true);
                  }}
                  name="isDepositeRecieved"
                  id="isDepositeRecieved"
                  color="primary"
                />
              }
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: "16px", // Set your desired font size here
                  display: "flex",
                },
              }}
            />
          )}
          <br />
          {formData?.isDepositAmountExceeds && (
            <Alert severity="error" sx={{ mb: 2, width: "100%" }}>
              Deposit received is more than quotation cost. please! update
              deposit invoice, for job confirmation.
            </Alert>
          )}
          {formData?.invoiceNumber && !formData?.isDepositeRecieved && (
            <Alert severity="info" sx={{ mb: 2, width: "100%" }}>
              Deposit Invoice is not paid.
            </Alert>
          )}

          {/* buttons */}
          <div
            style={{
              position: "fixed",
              borderTop: "1px solid #CCC",
              left: 40,
              bottom: 48,
              right: 40,
              background: "#FFF",
              // display: "flex",
              // justifyContent: "space-between",
              padding: "10px 20px",
              zIndex: 1,
            }}
          >
            <div style={{ paddingLeft: "19px" }}>
              {/* <CustomButton
                style={{ marginRight: "10px" }}
                title="Save"
                disabled={
                  leadDetails?.lead?.status === "COMPLETED" ||
                  leadDetails?.lead?.status === "JOB" ||
                  isDoorToDoorAccept
                    ? true
                    : false
                }
                onClick={(e) => handleSubmit()}
              /> */}
              <ConfirmationActions
                confirmationForm={formData}
                screenType={"confirmation"}
                isShowActionCalled={isShowActionCalled}
                setIsShowActionCalled={setIsShowActionCalled}
                setAnyChangeFieldValue={setAnyChangeFieldValue}
                anyChangeFieldValue={anyChangeFieldValue}
                setActionType={setActionType}
                actionType={actionType}
                validateForm={() => {
                  const { isError, localError } =
                    confirmationClientValidateForm(
                      formData,
                      isFullPackAccept,
                      isDoorToDoorAccept,
                      isTesterSection,
                    );

                  let mergedError = localError || {};
                  let hasErrors = isError;

                  // Check isQuoteAccepted
                  if (!formData?.isQuoteAccepted) {
                    mergedError = {
                      ...mergedError,
                      isQuoteAccepted: "Accepted Status is required",
                    };
                    hasErrors = true;
                  }

                  // Check Removal Service Status
                  const removalService = formData?.services?.find(
                    (service: any) =>
                      service?.type?.toLowerCase()?.replace(/\s+/g, "") ===
                      "removal",
                  );

                  if (!removalService || removalService?.status !== "accept") {
                    dispatch(
                      setNotificationAction({
                        severity: "error",
                        message: [
                          "Removal service must be accepted before proceeding.",
                        ],
                      }),
                    );

                    const modalContainer = document.getElementById(
                      "estimate-popup-fixed",
                    );

                    if (modalContainer) {
                      modalContainer.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }

                    return false;
                  }

                  setError(hasErrors ? mergedError : null);

                  if (hasErrors && mergedError) {
                    const firstErrorKey = Object.keys(mergedError)[0];

                    const targetInput = document.querySelector(
                      `input[name="${firstErrorKey}"], input[id="${firstErrorKey}"]`,
                    ) as HTMLElement | null;

                    if (targetInput) {
                      targetInput.focus();
                      targetInput.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                      });
                    }
                  }

                  return !hasErrors;
                }}
              />
              {/* <CustomButton
                title="Return"
                onClick={() => {
                  setFormData(clientConfirm);
                  setShow(false);
                  // setError(null)
                }}
              /> */}
              {/* {(selectedLeadEstimate || load) &&  */}
              <FormControlLabel
                label="VAT Included"
                labelPlacement="start"
                control={
                  <Checkbox
                    name="vatIncluded"
                    id="vatIncluded"
                    sx={{
                      marginTop: "0",
                      marginLeft: "0 !important",
                      width: "auto !important",
                    }}
                    checked={formData?.vatIncluded}
                    disabled={true}
                    onChange={(event) => {
                      setFormData({
                        ...formData,
                        vatIncluded: event.target.checked,
                      });
                    }}
                    color="primary"
                  />
                }
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "13px", // Set your desired font size here
                    display: "flex",
                  },
                }}
              />
              {/* } */}
            </div>
          </div>
        </Grid>
      </div>
    </>
  );
};
export default ManageProfessionalConfirmation;
